import React from "react";
import useAuthStore from "../../stores/useAuthStore";

const LetterHeader = () => {
  const { settings } = useAuthStore();

  return (
    <div className="resultHeader">
      <div>
        <img src={settings?.logo || "/images/college-logo.png"} alt={settings?.shortName || "Institution Logo"} />
      </div>
      <div>
        <div className="text-uppercase school-name p-1">
          {settings?.institutionName || "ADAMU TAFAWA BALEWA COLLEGE OF EDUCATION, KANGERE"}
        </div>
        <div className="p-1">
          {settings?.address || "Main Campus, Along Bauchi-Gombe Road, Kangere, Bauchi State"}
        </div>
        <div className="p-1">
          {settings?.affiliate && <span>Affiliated to {settings.affiliate}</span>}
        </div>
      </div>
    </div>
  );
};

export default LetterHeader;
